import styled from "styled-components";
import appShellUiVars from "_c/AppShell/ui-vars";

export const Wrap = styled.div`
  height: calc(100vh - ${appShellUiVars.headDesktopHeight} - 10px);
  position: relative;
  @media(max-width: ${appShellUiVars.mobileBp}px) {
    height: auto;
  }
`;
export const ControlsWrap = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  left: 10px;
  top: 10px;
  z-index: 2;
  > button {
    display: inline-flex;
    margin-right: 5px;
    :last-child {
      margin-right: 0;
    }
  }
`;
